import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend
);

export default function WaveChart({ data }) {
  const chartData = {
    labels: data.map((d) => d.period),
    datasets: [
      {
        label: "Klik Produk",
        data: data.map((d) => d.total),
        fill: true,
        borderColor: "#0d6efd",
        backgroundColor: "rgba(13,110,253,0.15)",
        tension: 0.4,
      },
    ],
  };

  return <Line data={chartData} />;
}
